import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import ShoppingBagIcon from "@redotech/redo-icons/shopping-bag-03.svg";
import { NumberFilterOperator } from "@redotech/redo-views-common/advanced-filters/number-filter";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.customerOrderCount;

export const CustomerOrderCountFilter: AdvancedTableFilter = {
  type: entry.type,
  Icon: ShoppingBagIcon,
  min: 0,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: NumberFilterOperator.GREATER_THAN,
  },
  displayName: entry.displayName,
};
